import { Variant } from '@kizi/core-components';

const baseTable: Variant = {
  color: 'main.2',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'body',
  width: '100%',
};

const baseTableCell: Variant = {
  width: '100%',
};

const baseTableHeading: Variant = {
  width: '100%',
};

const baseTableRow: Variant = {
  display: 'flex',
  width: '100%',
  'td, th': {
    width: '100%',
  },
};

const base: Variant = {
  ...baseTable,
  tr: {
    ...baseTableRow,
    td: baseTableCell,
    th: baseTableHeading,
  },
};

const comparison: Variant = {
  ...baseTable,
  tr: {
    ...baseTableRow,
    borderBottom: '1px solid',
    borderBottomColor: 'second.1',
    'td, th': {
      display: 'flex',
      my: 'auto',
      py: 3,
      textAlign: 'right',
      width: '20%',
      fontFamily: '"Segoe UI", sans-serif',
      fontSize: '0.875rem',
      lineHeight: 1.5,
      '&:first-of-type': {
        textAlign: 'left',
        width: '60%',
      },
      svg: {
        mx: 'auto',
      },
    },
    '&:first-of-type': {
      borderBottom: 'none',
    },
    '&:first-of-type > th': {
      paddingBottom: '0px',
    },
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
};

const productModal: Variant = {
  ...baseTable,
  fontSize: 3,
  tr: {
    ...baseTableRow,
    borderBottom: '1px solid',
    borderBottomColor: 'second.1',
    'td, th': {
      py: 3,
      textAlign: 'right',
      width: '20%',
      '&:first-of-type': {
        textAlign: 'left',
        width: '40%',
      },
    },
    '&:last-of-type': {
      fontWeight: 1,
      borderBottom: 'none',
    },
  },
};

const comparisonContainer: Variant = {
  color: 'main.2',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'body',
  fontSize: 2,
  td: {
    p: 0,
    display: 'flex',
  },
  '>tbody': {
    'tr:first-child': {
      paddingTop: 6,
    },
    'tr:last-child': {
      paddingBottom: 6,
    },
    '>tr:nth-child(1)>div:nth-child(1) ': {
      paddingTop: 6,
      '>:not(:first-child)': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
      },
    },
    '>tr:last-child': {
      '>div: only-child': {
        paddingBottom: 6,
        '> td > div': {
          borderBottom: 0,
        },
      },
      '>div:last-of-type:not(:only-of-type)': {
        paddingBottom: 6,
        '> div ': {
          '> div': {
            borderBottom: 0,
          },
          borderBottomLeftRadius: 2,
          borderBottomRightRadius: 2,
        },
      },
      '>div:nth-child(1) ': {
        '>:not(:first-child)': {
          borderBottomLeftRadius: 2,
          borderBottomRightRadius: 2,
        },
      },
    },
  },
  'td:not(:first-child)': {
    background: 'white',
    boxShadow: 'default',
    padding: '16px 24px 0 24px',
    '> div': {
      width: '100%',
      paddingBottom: 16,
      borderBottom: '1px solid',
      borderColor: 'second.1',
    },
  },
  tr: {
    columnGap: 6,
    verticalAlign: 'top',
    overflowY: 'hidden',
    display: 'flex',
    width: [null, null, null, '100%'],
    'td, th': {
      maxWidth: '275px',
      minWidth: '150px',
      py: 3,
      flex: 1,
    },
    '> div': {
      paddingRight: [3, 3, 3, 0],
    },
  },
  'tr:nth-child(1) > td:not(:first-child)': {
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
  },
  'tr:last-of-type > td:not(:first-child)': {
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
    '> div': {
      borderBottom: 'none',
      borderRadius: 24,
    },
  },
};

const tables = {
  base,
  productModal,
  comparison,
  comparisonContainer,
};

export default tables;
